export default "__VITE_PUBLIC_ASSET__68453f06__"